InputView = require("views/input")

class FreeTextView extends InputView
  template: require("./template")

  events: ->
    "iostap .content-fill": "focus"
    "iostap .btn-done": "nextSlide"

  show: ->
    @listenTo this, "resize", @onResize

  beforeShow: ->
    @setEl @findOne(".user-input"),  "input"
    @trigger("ui", flexibleHeight: true)

    if @serialize().min is 0 or
       @value?.length >= @serialize().min
      @setState("touched")

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  onResize: ->
    @beforeShow()

  serialize: ->
    data = super
    data.title = @options.data.question.content
    data.min   = @options.data.question.min
    data.min   = 0 unless data.min > 0
    data.value = @value
    data.hasPrompt = true
    data

  focus: ->
    inputEl = @getEl("input")
    { title, min, prompt } = @serialize()
    @changeState(true) if min is 0
    $("#text-input-view")
      .off("update")
      .trigger("open", { title, min, prompt, @value })
      .on("update", (e, v) => @onUpdate(v, inputEl))

  userInput: ->
    text: @value
    question:
      content: @options.data.question.content
      id: @options.data.question.id

  onUpdate: (@value, el) ->
    isComplete     = @value.length >= @serialize().min
    el.textContent = @value
    @changeState(isComplete)

  changeState: (isComplete) ->
    @setState(@value?.length > 0, "has-input")
    @setState(if isComplete then "touched" else "prompt")

module.exports = FreeTextView
